import React from 'react';

import { AlertResponse } from '@ariksa/notification/api';
import { Box, HStack } from '@chakra-ui/react';

import { renderSeverityBar, StackedHeader } from 'components/DataDisplay';
import { Drawer } from 'components/Overlay';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { AlertDetailsContent } from 'containers/Findings/AlertDrawer/Components/Aggregated/AlertDetailsContent';

interface AlertDetailsDrawerProps {
  alert: AlertResponse;
  isOpen: boolean;
  onClose: () => void;
}

export const AlertDetailsDrawer = (props: AlertDetailsDrawerProps) => {
  const { alert, isOpen, onClose } = props;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      header={
        <HStack justify={'space-between'}>
          <StackedHeader
            type={alert.resource!}
            upper={alert.message}
            lower={renderSeverityBar({
              value: alert.severity,
              labelStyles: {
                fontSize: 'md',
              },
            })}
          />
        </HStack>
      }
      body={
        <ActiveResourceProvider>
          <Box h="full" w="full" pt={3}>
            <AlertDetailsContent alert={alert} />
          </Box>
        </ActiveResourceProvider>
      }
      closeButton
      styles={{
        content: { maxW: '1570px' },
        drawer: {
          trapFocus: false,
          portalProps: {},
          blockScrollOnMount: false,
        },
      }}
    />
  );
};
